import { render, staticRenderFns } from "./receivingAddressModal.vue?vue&type=template&id=d5e57870&scoped=true"
import script from "./receivingAddressModal.vue?vue&type=script&lang=js"
export * from "./receivingAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e57870",
  null
  
)

export default component.exports